module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductCategoriesView.js"));
	}, "ProductCategoriesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductCategoriesView!./src/pages/Shop/Product/ProductCategories/ProductCategoriesView.js
// module id = 843
// module chunks = 438